import { TaxiCorporationUnbilledRouteListItem } from "../../../../../common/services/taxi-corporation/unbilled/route-list/taxi-corporation-unbilled-route-list";
import BillingsTaxiUnbilledRouteListingItem from "./types/billings-taxi-unbilled-route-listing-item";

const createListingItem = (
  responseDataItem: TaxiCorporationUnbilledRouteListItem,
): BillingsTaxiUnbilledRouteListingItem => {
  return {
    uuid: responseDataItem.uuid,
    routeId: responseDataItem.humanId,
    driverName: responseDataItem.driver,
    startDate: responseDataItem.startTime,
    addresses: responseDataItem.addresses.join(", "),
    orderIds: responseDataItem.cargoOrderHumanIds,
    clients: responseDataItem.clients.join(", "),
    fleetPartner: responseDataItem.fleetPartner,
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationUnbilledRouteListItem[],
): BillingsTaxiUnbilledRouteListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const billingsTaxiUnbilledRouteListingFactory = {
  createListingItems,
};

export default billingsTaxiUnbilledRouteListingFactory;
